export default __webpack_public_path__ + "locales/sk/DeleteDialog.json?hash=c9b1c6a8b4f56591adfe2614d1f286b8";